import { useEffect, useState } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const PARTICLE_COUNT = 18;

export default function PlayButtonExplosion({ trigger, scale = 1 }) {
  const [burst, setBurst] = useState(null);

  useEffect(() => {
    if (!trigger) return;
    if (prefersReducedMotion()) return;
    setBurst({ key: trigger });
    const t = setTimeout(() => setBurst(null), 950);
    return () => clearTimeout(t);
  }, [trigger]);

  if (!burst) return null;

  const particles = Array.from({ length: PARTICLE_COUNT }, (_, i) => {
    const angle = (i / PARTICLE_COUNT) * Math.PI * 2 + (Math.random() - 0.5) * 0.25;
    const dist = (90 + Math.random() * 70) * scale;
    const dx = Math.cos(angle) * dist;
    const dy = Math.sin(angle) * dist;
    const delay = Math.random() * 60;
    const size = (4 + Math.random() * 6) * scale;
    const hueShift = Math.random() * 30 - 10;
    return { i, dx, dy, delay, size, hueShift };
  });

  return (
    <div key={burst.key} className="play-explosion" style={{ '--exp-scale': scale }} aria-hidden="true">
      <span className="play-explosion-flash" />
      <span className="play-explosion-ring play-explosion-ring--1" />
      <span className="play-explosion-ring play-explosion-ring--2" />
      <span className="play-explosion-ring play-explosion-ring--3" />
      {particles.map((p) => (
        <span
          key={p.i}
          className="play-explosion-ember"
          style={{
            '--dx': `${p.dx}px`,
            '--dy': `${p.dy}px`,
            '--sz': `${p.size}px`,
            '--hs': `${p.hueShift}deg`,
            animationDelay: `${p.delay}ms`,
          }}
        />
      ))}
    </div>
  );
}
